import { render } from "./MindarViewer.vue?vue&type=template&id=abb6309a"
import script from "./MindarViewer.vue?vue&type=script&lang=js"
export * from "./MindarViewer.vue?vue&type=script&lang=js"

import "./MindarViewer.vue?vue&type=style&index=0&id=abb6309a&lang=css"

import exportComponent from "/home/lw8dl1214/actions-runner/_work/AIPR-Frontend/AIPR-Frontend/haleon-ar-detector/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__